module.exports = __webpack_public_path__ + "img/logo-nav.d18c9d5f.png";